// A board with a handful of names reads as a dead program, so everyone else
// waits for a full top 10. Internal users always see it to keep an eye on it.
export const PUBLIC_MIN_ENTRIES = 10;

export const showReferralLeaderboard = (
  userGroupType: string | null | undefined,
  entryCount: number,
) =>
  entryCount > 0 &&
  (userGroupType === "INTERNAL" || entryCount >= PUBLIC_MIN_ENTRIES);
